import { render, staticRenderFns } from "./ExamSummary.vue?vue&type=template&id=06cfef8c&scoped=true"
import script from "./ExamSummary.vue?vue&type=script&lang=js"
export * from "./ExamSummary.vue?vue&type=script&lang=js"
import style0 from "./ExamSummary.vue?vue&type=style&index=0&id=06cfef8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfef8c",
  null
  
)

export default component.exports